<template>
  <div>
    <el-card>
      <div v-show="!pinshengIsShow && !modelDB && !documentIsShow">
        <!-- 头部 -->
        <el-row :gutter="24">
          <el-col :span="8">
            <div style="font-size: 30px">
              我的评审任务&nbsp;&nbsp;&nbsp;
              <span style="font-size: 26px">{{ time }}</span>
            </div>
          </el-col>
          <el-col :span="5" :offset="11">
            <el-select
              v-model="planid"
              style="width: 100%"
              filterable
              placeholder="请选择"
              @change="changePlanid"
            >
              <el-option
                v-for="item in list"
                :key="item.zwpp01"
                :label="item.zwpp03"
                :value="item.zwpp01"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <!-- echarts -->
        <el-row :gutter="24" style="height: 230px">
          <el-col :span="3" :offset="0" style="text-align: right">
            <div class="flex" style="font-size: 14px; justify-content: left">
              <h2>总审核项</h2>
              <h1
                style="
                  font-weight: 700;
                  color: #000;
                  font-size: 32px;
                  margin-left: 10px;
                "
              >
                {{ zong }}
              </h1>
            </div>
            <div
              class="flex"
              style="font-size: 14px; justify-content: left; margin: 20px 0"
            >
              <h2>审核中任务数</h2>
              <h1
                style="
                  font-weight: 700;
                  color: #8666ba;
                  font-size: 32px;
                  margin-left: 10px;
                "
              >
                {{ shz }}
              </h1>
            </div>
            <div class="flex" style="font-size: 14px; justify-content: left">
              <h2>已审核任务数</h2>
              <h1
                style="
                  font-weight: 700;
                  color: #42b789;
                  font-size: 32px;
                  margin-left: 10px;
                "
              >
                {{ ysh }}
              </h1>
            </div>
          </el-col>
          <el-col :span="3" :offset="0" style="text-align: right">
            <div class="flex" style="font-size: 14px; justify-content: left">
              <h2>未审核任务数</h2>
              <h1
                style="
                  font-weight: 700;
                  color: #f98017;
                  font-size: 32px;
                  margin-left: 10px;
                "
              >
                {{ wsh }}
              </h1>
            </div>
            <div
              class="flex"
              style="font-size: 14px; justify-content: left; margin: 20px 0"
            >
              <h2>已延期审核项</h2>
              <h1
                style="
                  font-weight: 700;
                  color: #ff0000;
                  font-size: 32px;
                  margin-left: 10px;
                "
              >
                {{ yyq }}
              </h1>
            </div>
          </el-col>
          <el-col :span="6" :offset="0" style="height: 100%">
            <v-chart
              theme="macarons"
              id="chart1"
              style="width: 100%"
              :options="polar"
            />
            <!-- <div id="chart1" style="width: 100%; height: 100%"></div> -->
          </el-col>
          <el-col :span="6" :offset="0" style="height: 100%">
            <v-chart
              theme="macarons"
              id="chart2"
              style="width: 100%"
              :options="polar1"
            />
          </el-col>
          <el-col :span="6" :offset="0" style="height: 100%">
            <v-chart
              theme="macarons"
              id="chart3"
              style="width: 100%"
              :options="polar2"
            />
          </el-col>
        </el-row>
      </div>
      <!-- 模型展示 -->
      <div
        style="width: 100%; height: 700px; position: relative"
        v-show="pinshengIsShow && !modelDB"
      >
        <el-button
          type="danger"
          size="mini"
          style="position: absolute; right: 0; z-index: 2"
          @click="pinshengIsShow = false"
          >关闭</el-button
        >
        <el-button
          type="danger"
          size="mini"
          style="position: absolute; top: 10px; z-index: 2"
          v-show="modelLoad"
          @click="viewpointSave"
          >视点保存</el-button
        >
        <el-button
          type="danger"
          size="mini"
          v-show="modelLoad && !isTuZhi"
          style="position: absolute; left: 100px; top: 10px; z-index: 2"
          @click="pengzhuang"
          >模型碰撞</el-button
        >
        <el-button
          type="danger"
          size="mini"
          v-show="modelLoad && !isTuZhi"
          style="position: absolute; left: 200px; top: 10px; z-index: 2"
          @click="modelDuibi(1)"
        >
          模型对比
        </el-button>
        <div id="MyViewerDiv" class="model"></div>
        <canvas id="snapshot" hidden></canvas>
        <!-- 碰撞检查 -->
        <div class="crashCheck_box" id="crashCheckDiv">
          <div class="box_title">碰撞检查</div>
          <div class="btnClose" onclick="CrashCheck.close()">×</div>
          <div class="box_content">
            <div class="tab_title">
              <ul id="crashCheck_tabs" class="clearfix">
                <li
                  class="current"
                  style="width: 33%"
                  onclick="CrashCheck.select(this)"
                >
                  <a href="#" title="选择构件">选择构件</a>
                </li>
                <li style="width: 33%" onclick="CrashCheck.select(this)">
                  <a href="#" title="碰撞结果">碰撞结果</a>
                </li>
                <li
                  style="width: 33%"
                  @click="GetCrashCheck"
                  onclick="CrashCheck.select(this)"
                >
                  <a href="#" title="碰撞结果">碰撞报告</a>
                </li>
              </ul>
            </div>
            <div id="menu_crashCheck_content_box">
              <div id="crashCheck_tab1" class="menu_table dis-bok">
                <div class="box">
                  <div class="tree">
                    <ul id="crashCheck_tree1" class="ztree"></ul>
                  </div>
                  <el-button
                    style="width: 94%; margin-left: 5%"
                    size="small"
                    type="primary"
                    onclick="CrashCheck.export('crashCheck_tree1')"
                  >
                    导入目前选择构件
                  </el-button>
                </div>
                <div class="box">
                  <div class="tree">
                    <ul id="crashCheck_tree2" class="ztree"></ul>
                  </div>
                  <el-button
                    style="width: 94%; margin-left: 5%"
                    size="small"
                    type="primary"
                    onclick="CrashCheck.export('crashCheck_tree2')"
                    >导入目前选择构件</el-button
                  >
                </div>
                <el-button
                  style="width: 94%; margin-left: 3%"
                  size="small"
                  type="primary"
                  onclick="CrashCheck.todo()"
                  >进行碰撞</el-button
                >
                <el-upload
                  style="width: 100%; margin-top: 4px"
                  class="upload-demo"
                  :action="actionS"
                  :headers="importHeaders"
                  :data="uploadData"
                  :before-upload="beforeUpload"
                  :on-success="uploadSuccess"
                  v-loading="uploadLoading"
                  accept=".xml"
                >
                  <el-button style="width: 94%" size="small" type="warning"
                    >上传碰撞报告</el-button
                  >
                </el-upload>
              </div>
              <div id="crashCheck_tab2" class="menu_table dis-none">
                <div class="tree" style="height: 94%">
                  <ul
                    id="crashCheck_resultTree"
                    class="ztree"
                    style="height: 90%"
                  ></ul>
                  <div id="rMenu_crashCheck" class="rMenu pos-fixed">
                    <ul id="rShowMenu_crashCheck">
                      <li
                        id="cc_m_del"
                        class="dis-lis-item"
                        onclick="CrashCheck.removeTreeNode()"
                      >
                        删除
                      </li>
                    </ul>
                  </div>
                </div>
                <el-button
                  style="width: 94%; margin-left: 5%"
                  size="small"
                  type="primary"
                  @click="AddCrashCheckOpen"
                >
                  保存
                </el-button>
              </div>
              <div id="crashCheck_tab3" class="menu_table dis-none">
                <div class="tree">
                  <ul
                    id="crashCheck_baoGaoTree"
                    class="ztree"
                    style="height: 90%"
                  ></ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 视点保存 -->
        <div
          id="div_viewpoint"
          class="m-right-sidebar"
          style="right: 10%; height: 670px; top: 10%; display: none"
        >
          <h2 class="sdbcName">视点保存</h2>
          <div
            class="btnClose close_bt_p"
            onclick="ZJWJViewPoint.hiddenViewPoint();"
          >
            ×
          </div>
          <div class="body_viewpoint">
            <div
              id="viewpointUser"
              style="width: 100%; max-height: 10%; overflow: auto"
            ></div>
            <ul id="treeDemo_viewpoint" class="treeDemo_viewpoint ztree"></ul>
          </div>
          <div class="w-h-bg-cor">
            <el-button
              type="primary"
              id="vp-btn-mark"
              data-placement="bottom"
              data-toggle="tooltip"
              title="涂鸦"
              size="small"
              onclick="ZJWJViewPoint.showMarkTool()"
              >涂鸦</el-button
            >

            <el-button
              type="primary"
              id="vp-btn-save"
              data-placement="bottom"
              data-toggle="tooltip"
              size="small"
              title="保存"
              onclick="ZJWJViewPoint.onSaveLayer()"
              >保存</el-button
            >
          </div>
          <div id="rMenu_viewpoint" class="rMenu pos-fixed">
            <ul id="rShowMenu_viewpoint">
              <li
                id="vp_m_add"
                class="dis-lis-item"
                onclick="ZJWJViewPoint.addTreeNode()"
              >
                新建视点目录
              </li>
              <li
                id="vp_m_del"
                class="dis-lis-item"
                onclick="ZJWJViewPoint.removeTreeNode()"
              >
                删除
              </li>
              <li
                id="vp_m_ren"
                class="dis-lis-item"
                onclick="ZJWJViewPoint.renameTreeNode()"
              >
                重命名
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- 这里是模型对比 -->
      <div
        class="ModelCompare"
        v-show="!pinshengIsShow && !documentIsShow && modelDB"
      >
        <el-button
          type="danger"
          size="mini"
          style="position: absolute; right: 0px; z-index: 2"
          @click="modelDuibi(2)"
        >
          
          {{ $t('common.关闭') }}
        </el-button>
        <div id="model1" class="model"></div>
        <div class="myBorder">
          <el-button
            @click="ModelCompare"
            class="myborder-el-button"
            title="比对"
            icon="el-icon-s-help"
            circle
          ></el-button>
          <div class="divs">
            <div title="删除">删除</div>
            <div title="增加">增加</div>
            <div title="变更前">变更前</div>
            <div title="变更后">变更后</div>
          </div>
        </div>
        <div id="model2" class="model model3"></div>
        <el-select class="modelListOne" v-model="model1" placeholder="请选择">
          <el-option
            v-for="item in modelList"
            :key="item.zwpm01"
            :label="item.zwpm03"
            :value="item.zwpm01"
            @click.native="model1Change(item)"
          ></el-option>
        </el-select>
        <el-select class="modelListTwo" v-model="model2" placeholder="请选择">
          <el-option
            v-for="item in modelList"
            @click.native="model2Change(item)"
            :key="item.zwpm01"
            :label="item.zwpm03"
            :value="item.zwpm01"
          ></el-option>
        </el-select>
      </div>

      <!-- 文档 -->
      <div
        style="width: 100%; height: 700px; position: relative"
        v-show="!pinshengIsShow && !modelDB && documentIsShow"
      >
        <el-row>
          <el-col :span="12">
            <iframe
              width="100%"
              height="700px"
              :src="iframeUrl"
              frameborder="0"
            ></iframe>
          </el-col>
          <el-col :span="12" style="height: 700px; overflow-y: auto">
            <el-button
              style="position: absolute; right: -15px; top: -20px"
              type="danger"
              size="mini"
              @click="documentIsShow = false"
              >关闭</el-button
            >
            <el-row style="margin-top: 10px">
              <el-col :span="3" :offset="21">
                <el-button
                  type="danger"
                  size="mini"
                  @click="
                    auditShow = true;
                    zjwj_fileaudit.zwfa03 = '';
                    bianjiAudit = false;
                  "
                  >{{$t('common.添加批注')}}</el-button
                >
              </el-col>
            </el-row>
            <div v-if="auditShow">
              <ckediter4 ref="ck"></ckediter4>
              <el-row style="margin-top: 10px">
                <el-col :span="2" :offset="20">
                  <el-button
                    type="danger"
                    size="mini"
                    @click="auditShow = false"
                    icon="el-icon-error"
                  ></el-button>
                </el-col>
                <el-col :span="2">
                  <el-button
                    type="primary"
                    size="mini"
                    @click="AddFileAudit"
                    icon="el-icon-success"
                  ></el-button>
                </el-col>
              </el-row>
            </div>
            <el-table max-height="200px" :data="fileAuditList">
              <el-table-column
                property="user04"
                label="创建人"
              ></el-table-column>
              <el-table-column
                property="zwfa05"
                label="创建时间"
              ></el-table-column>

              <el-table-column>
                <template slot-scope="scope">
                  <el-button
                    type="primary"
                    size="mini"
                    @click="viewFileAudit(scope.row)"
                    >查看</el-button
                  >
                  <el-button
                    type="danger"
                    size="mini"
                    @click="DelFileAudit(scope.row)"
                  >
                    删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>

            <div
              style="width: 100%; height: 700px; overflow: auto"
              v-if="bianjiAudit"
            >
              <el-row style="margin-top: 10px">
                <el-col :span="2" :offset="22">
                  <el-button
                    type="danger"
                    size="mini"
                    @click="bianjiAudit = false"
                    icon="el-icon-error"
                  ></el-button>
                </el-col>
              </el-row>
              <div v-html="zjwj_fileaudit.zwfa03">
                {{ zjwj_fileaudit.zwfa03 }}
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <!--  ---------------- -->
      <!-- 风险预警 -->
      <el-row style="margin-top: 10px">
        <el-col :span="3">
          <div
            style="
              width: 60px;
              height: 30px;
              background-color: red;
              border-radius: 4px;
              float: left;
            "
          ></div>
          <p style="margin: 5px 0 0 10px; float: left">风险预警</p>
        </el-col>
      </el-row>
      <!-- 表格 -->
      <el-row :gutter="24" style="margin-top: 15px">
        <el-table
          :data="tableList"
          ref="multipleTable"
          tooltip-effect="dark"
          :row-class-name="tableRowClassName"
          style="width: 100%"
          height="600px"
          row-key="zwpd01"
          :highlight-current-row="true"
          default-expand-all
          :tree-props="{ children: 'children' }"
          v-loading="loading2"
        >
          <el-table-column property="zwpd04" fixed width="200" label="任务名称">
            <template slot-scope="scope">
              <span>{{ scope.row.zwpd04 }}</span>
            </template>
          </el-table-column>
          <el-table-column property="user02" width="150" label="发起人">
          </el-table-column>
          <el-table-column label="责任人" width="150" align="center" prop="b">
            <template slot-scope="scope">
              <el-select v-model="scope.row.fzId">
                <el-option
                  :label="item.user04"
                  :title="item.user02"
                  :value="item.user01"
                  v-for="item in scope.row.fzList"
                  :key="item.user01"
                ></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="审核人" width="150" align="center" prop="c">
            <template slot-scope="scope">
              <el-select v-model="scope.row.shId">
                <el-option
                  :label="item.user04"
                  :title="item.user02"
                  :value="item.user01"
                  v-for="item in scope.row.shList"
                  :key="item.user01"
                ></el-option>
              </el-select> </template
          ></el-table-column>
          <el-table-column property="state" width="200" label="状态">
            <template slot-scope="scope">
              <p
                :style="{
                  background: scope.row.isAuditDanger === 1 ? 'red' : '',
                  textAlign: 'center',
                  color: '#606266',
                  height: '28px',
                  lineHeight: '28px',
                  borderRadius: '10px',
                }"
              >
                {{ scope.row.auditstate }}
              </p>
            </template>
          </el-table-column>

          <el-table-column property="zwpd06" label="成果评审">
            <el-table-column property="" label="BIM模型" width="200">
              <template
                slot-scope="scope"
                v-if="scope.row.children.length === 0"
              >
                <el-select v-model="scope.row.mId">
                  <el-option
                    v-for="item in scope.row.fileList.filter(
                      (ele) => ele.zwpm08 === 1
                    )"
                    :key="item.zwpm01"
                    :label="item.zwpm03"
                    :value="item.zwpm01"
                    @click.native="viewModelOpen(item, scope.row)"
                  >
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column property="" label="CAD图纸" width="200">
              <template
                slot-scope="scope"
                v-if="scope.row.children.length === 0"
              >
                <el-select v-model="scope.row.cadId">
                  <el-option
                    v-for="item in scope.row.fileList.filter(
                      (ele) => ele.zwpm08 === 3
                    )"
                    :key="item.zwpm01"
                    :label="item.zwpm03"
                    :value="item.zwpm01"
                    @click.native="viewModelOpen(item, scope.row)"
                  >
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column property="" label="工程文档" width="200">
              <template
                slot-scope="scope"
                v-if="scope.row.children.length === 0"
              >
                <el-select v-model="scope.row.wdId">
                  <el-option
                    v-for="item in scope.row.fileList.filter(
                      (ele) => ele.zwpm08 === 4
                    )"
                    @click.native="documentOpen(item, scope.row)"
                    :key="item.zwpm01"
                    :label="item.zwpm03"
                    :value="item.zwpm01"
                  >
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column property="zwpd05" width="200" label="计划开始时间">
          </el-table-column>
          <el-table-column property="zwpd06" width="200" label="计划完成时间">
          </el-table-column>
          <el-table-column property="zwpd09" width="200" label="实际开始时间">
          </el-table-column>
          <el-table-column property="zwpd10" width="200" label="实际结束时间">
          </el-table-column>
          <el-table-column property="zwpd11" label="备注"> </el-table-column>
          <el-table-column label="操作" fixed="right" width="250">
            <template slot-scope="scope" v-if="scope.row.children.length === 0">
              <el-button
                type="warning"
                size="mini"
                v-if="scope.row.zwpd16 == null && scope.row.zwpd17 == null"
                @click="ZjwjStartPlan(scope.row)"
                >审核</el-button
              >
              <el-button
                v-if="
                  scope.row.zwpd17 == null &&
                  scope.row.zwpd16 != null &&
                  localStorage.id == scope.row.shId
                "
                type="danger"
                size="mini"
                @click="bohuiIsShowOpen(scope.row)"
                >驳回</el-button
              >
              <el-button
                v-if="
                  scope.row.zwpd17 == null &&
                  scope.row.zwpd16 != null &&
                  localStorage.id == scope.row.shId
                "
                type="success"
                size="mini"
                @click="ZjwjPlanAuditPassTrue(scope.row)"
                >通过</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-row>
    </el-card>
    <!-- 驳回 -->
    <el-dialog :close-on-click-modal = "false"
      title="任务驳回"
      :visible.sync="bohuiIsShow"
      width="30%"
      top="2%"
    >
      <el-form ref="form" :model="zjwj_planaudit" label-width="150px">
        <el-form-item label="修改内容">
          <el-input
            type="textarea"
            v-model="zjwj_planaudit.zwpa04"
            style="width: 100%"
          ></el-input> </el-form-item
        ><el-form-item label="延长计划完成时间">
          <el-date-picker
            v-model="zjwj_planaudit.zwpa06"
            type="datetime"
            placeholder="选择日期时间"
            style="width: 100%"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="模型选择">
          <el-select
            style="width: 100%"
            multiple
            v-model="bohuilist.modelId"
            placeholder="请选择"
          >
            <el-option
              v-for="item in modelList"
              :key="item.zwpm01"
              :label="item.zwpm03"
              :value="item.zwpm01"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="图纸选择">
          <el-select
            style="width: 100%"
            multiple
            v-model="bohuilist.tuzhiId"
            placeholder="请选择"
          >
            <el-option
              v-for="item in tuzhiList"
              :key="item.zwpm01"
              :label="item.zwpm03"
              :value="item.zwpm01"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="文档选择">
          <el-select
            style="width: 100%"
            multiple
            v-model="bohuilist.documentId"
            placeholder="请选择"
          >
            <el-option
              v-for="item in documentList"
              :key="item.zwpm01"
              :label="item.zwpm03"
              :value="item.zwpm01"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="bohuiIsShow = false">取 消</el-button>
        <el-button type="primary" @click="ZjwjPlanAuditNoPass">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 添加碰撞报告 -->
    <el-dialog :close-on-click-modal = "false"
      title="添加碰撞报告"
      :visible.sync="AddCrashCheckIsShow"
      width="40%"
      top="2%"
    >
      <el-form ref="form" :model="zjwj_crashcheck" label-width="150px">
        <el-form-item label="名称">
          <el-input
            type="text"
            v-model="zjwj_crashcheck.zwcc03"
            style="width: 100%"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            type="textarea"
            v-model="zjwj_crashcheck.zwcc05"
            style="width: 100%"
          ></el-input>
        </el-form-item> </el-form
      ><span slot="footer" class="dialog-footer">
        <el-button @click="AddCrashCheckIsShow = false">取 消</el-button>
        <el-button type="primary" @click="AddCrashCheck">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  GetZjwjProjectPlan,
  ZjwjMyToAudit,
  ZjwjStartPlan,
  ZjwjPlanAuditPass,
  ZjwjPlanAuditNoPass,
  AddCrashCheck,
  GetCrashCheck,
  Office2Pdf,
  GetFileAudit,
  DelFileAudit,
  AddFileAudit,
} from "@/setAxios.js";
import ckediter4 from "@/components/ck.vue";
export default {
  name: "",
  components: { ckediter4 },
  props: {},
  data() {
    return {
      localStorage: {
        id: localStorage.id,
      },
      isTuZhi: false,
      modelLoad: false,
      AddFileAuditOpen: false,
      documentIsShow: false,
      iframeUrl: "",
      zjwj_fileaudit: {
        zwfa01: "",
        zwfa02: "",
        zwfa03: "",
        zwfa04: localStorage.id,
        zwfa05: new Date(),
      },
      fileAuditList: [],
      auditShow: false,
      bianjiAudit: false,
      // ----------------
      modelDB: false,
      model1: "",
      model2: "",
      model1Nanme: "",
      model1Nanme: "",
      model1Path: "",
      model2Path: "",
      loading: null,
      // ----------------
      zjwj_crashcheck: {
        zwcc01: "",
        zwcc02: "",
        zwcc03: "",
        zwcc04: "",
        zwcc05: "",
        zwcc06: "",
        zwcc07: new Date(),
      },
      AddCrashCheckIsShow: false,
      actionS: this.$store.state.baseUrl + "/api/ImportXml",
      importHeaders: { token: localStorage.getItem("token") },
      uploadData: { cid: localStorage.pid, xid: localStorage.xid },
      uploadLoading: false,
      zong: 0,
      yshzc: 0,
      shzzc: 0,
      wshzc: 0,
      yshyq: 0,
      shzyq: 0,
      wshyq: 0,
      wsh: 0,
      shz: 0,
      ysh: 0,
      yyq: 0,
      zc: 0,
      zcx: 0,
      fxx: 0,
      modelList: [],
      tuzhiList: [],
      documentList: [],
      zjwj_planaudit: {
        zwpa01: "",
        zwpa02: "",
        zwpa03: localStorage.id,
        zwpa04: "",
        zwpa05: new Date(),
        zwpa06: "",
      },
      bohuilist: {
        modelId: [],
        tuzhiId: [],
        documentId: [],
      },
      form: {
        name: "",
        Time: null,
        value: "",
      },
      bohuiIsShow: false,
      pinshengIsShow: false,
      list: [],
      planid: "",
      palnDetailid: "",
      searchword: "",
      tableList: [],
      type: 1,
      loading2: false,
      input: "",
      dialogTableVisible: false,
      time: new Date().toLocaleString("chinese", { hour12: false }),
      polar: {},
      polar1: {},
      polar2: {},
    };
  },
  created() {
    this.GetZjwjProjectPlan();
  },
  mounted() {
    setInterval(() => {
      this.time = new Date().toLocaleString("chinese", { hour12: false });
    }, 1000);
  },
  methods: {
    viewpointSave() {
      ZJWJViewPoint.init(ZJWJ.viewer, ZJWJ.modelData);
    },
    pengzhuang() {
      CrashCheck.init(ZJWJ.viewer);
    },
    viewFileAudit(data) {
      this.bianjiAudit = true;
      this.auditShow = false;
      this.zjwj_fileaudit.zwfa03 = data.zwfa03;
    },
    async DelFileAudit(data) {
      let res = await DelFileAudit({ id: data.zwfa01 });
      if (res.Code > 0) {
        this.$message({
          type: "success",
          message: "删除成功",
        });
        this.GetFileAudit();
      }
    },
    async AddFileAudit() {
      this.zjwj_fileaudit.zwfa03 = this.$refs.ck.ckeditor.getData();
      if (this.zjwj_fileaudit.zwfa03 === "") {
        this.$message({
          type: "warning",
          message: "请输入文档描述",
        });
        return;
      }
      let res = await AddFileAudit({ model: this.zjwj_fileaudit });
      if (res.Code > 0) {
        this.$message({
          type: "success",
          message: "添加成功",
        });
        this.zjwj_fileaudit.zwfa03 = "";
        this.auditShow = false;
        this.GetFileAudit();
      }
    },
    async GetFileAudit() {
      let res2 = await GetFileAudit({
        params: { id: this.zjwj_fileaudit.zwfa02 },
      });
      this.fileAuditList = res2.Data;
    },
    async documentOpen(item, data) {
      this.documentIsShow = true;
      this.pinshengIsShow = false;
      this.modelDuibi = false;
      if (
        item.zwpm04
          .split(".")
          [item.zwpm04.split(".").length - 1].toLowerCase() == "pdf"
      ) {
        this.iframeUrl = this.$store.state.baseUrl + item.zwpm04;
      } else {
        let res = await Office2Pdf({ sourcePath: item.zwpm04 });
        if (res.Code === 0) {
          this.$message({
            type: "warning",
            message: res.Message,
          });
        } else {
          this.iframeUrl = this.$store.state.baseUrl + res.Data;
        }
      }
      this.zjwj_fileaudit.zwfa02 = item.zwpm01;
      this.GetFileAudit();
    },
    // ----------------
    modelDuibi(type) {
      if (type === 1) {
        this.pinshengIsShow = false;
        this.modelDB = true;
      } else {
        this.pinshengIsShow = true;
        this.modelDB = false;
      }
    },
    openFullScreen2() {
      this.loading = this.$loading({
        lock: true,
        text: "比对中，请稍等...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
    },
    model1Change(val) {
      this.model1Nanme = val.zwpm03;
      this.model1Path = val.zwpm04;
      var path = this.$store.state.baseUrl + val.zwpm04;
      modelCompare.viewer1Load(path);
    },
    model2Change(val) {
      this.model2Nanme = val.zwpm03;
      this.model2Path = val.zwpm04;
      var path = this.$store.state.baseUrl + val.zwpm04;
      modelCompare.viewer2Load(path);
    },
    ModelCompare() {
      if (this.model1 == "" || this.model2 == "") {
        this.$message({
          type: "warning",
          message: "请选择模型",
        });
      } else {
        if (!this.model1Path == this.model2Path) {
          this.$message({
            type: "warning",
            message: "请选择不同的模型进行比对",
          });
        } else if (modelCompare.viewer1IsLoad && modelCompare.viewer2IsLoad) {
          var length = modelCompare.getViewerLenth();
          var msg = `${this.model1Nanme}（模型1）共有<b>${length[0]}</b>个构件,${this.model2Nanme}（模型2）共有<b>${length[1]}</b>个构件,是否进行比对？`;
          if (length[0] > 10000 || length[1] > 10000) {
            msg = `${this.model1Nanme}（模型1）共有<b>${length[0]}</b>个构件,${this.model2Nanme}（模型2）共有<b>${length[1]}</b>个构件,
             检测到模型较大，比对时间较长，是否进行比对？`;
          }
          this.$confirm(msg, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            dangerouslyUseHTMLString: true,
          }).then(() => {
            this.openFullScreen2();
            modelCompare.ModelCompare();
            var _Interval = setInterval(() => {
              if (modelCompare.compareComplete) {
                window.clearInterval(_Interval);
                this.loading.close();
                this.$message({
                  type: "success",
                  message: "比对完成",
                });
              }
            }, 1000);
          });
        } else {
          this.$message({
            type: "warning",
            message: "请等待模型加载完毕",
          });
        }
      }
    },
    // ----------------
    async GetCrashCheck() {
      let params = {
        id: this.zjwj_crashcheck.zwcc02,
      };
      let res = await GetCrashCheck({ params });
      if (res.Data.length > 0) {
        CrashCheck.initCrashCheckBaoGao(res.Data);
      }
    },
    async AddCrashCheck() {
      this.zjwj_crashcheck.zwcc04 = JSON.stringify(
        CrashCheck.resultTree.getNodes()
      );
      if (this.zjwj_crashcheck.zwcc04.length === 0) {
        this.$message({
          type: "warning",
          message: "当前暂无碰撞数据",
        });
        return;
      }
      let res = await AddCrashCheck({ model: this.zjwj_crashcheck });
      if (res.Code > 0) {
        this.$message({
          type: "success",
          message: "上传成功",
        });
        this.AddCrashCheckIsShow = false;
      }
    },
    AddCrashCheckOpen() {
      this.AddCrashCheckIsShow = true;
    },
    beforeUpload(file) {
      this.uploadLoading = true;
      var ext = file.name
        .substring(file.name.lastIndexOf(".") + 1)
        .toLowerCase();
      const xml = ext == "xml";
      if (!xml) {
        this.$message.error("上传文件只能是 xml 格式!");
        this.uploadLoading = false;
      }
      return xml;
    },
    uploadSuccess(res) {
      if (res.Code > 0) {
        this.$message({
          type: "success",
          message: "上传成功",
        });
        CrashCheck.xmlData(res.Data);
      } else {
        this.$message({
          type: "warning",
          message: res.Message,
        });
      }
      this.uploadLoading = false;
    },
    async ZjwjPlanAuditPassTrue(data) {
      this.$confirm("是否通过?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        let params = {
          id: data.zwpd01,
        };
        let res = await ZjwjPlanAuditPass(params);
        if (res.Code > 0) {
          this.$message({
            type: "success",
            message: "已通过",
          });
          this.ZjwjMyToAudit();
        }
      });
    },
    bohuiIsShowOpen(data) {
      this.bohuiIsShow = true;
      this.zjwj_planaudit.zwpa02 = data.zwpd01;
      this.modelList = data.fileList.filter((ele) => ele.zwpm08 === 1);
      this.tuzhiList = data.fileList.filter((ele) => ele.zwpm08 === 3);
      this.documentList = data.fileList.filter((ele) => ele.zwpm08 === 4);
    },
    async ZjwjPlanAuditNoPass() {
      let list = [];
      if (this.bohuilist.modelId.length > 0) {
        let zjwj_auditdata = {
          zwad01: 0,
          zwad02: 0,
          zwad03: this.bohuilist.modelId.join(","),
          zwad04: 1,
          zwad05: localStorage.id,
          zwad06: new Date(),
        };
        list.push(zjwj_auditdata);
      }
      if (this.bohuilist.tuzhiId.length > 0) {
        let zjwj_auditdata = {
          zwad01: 0,
          zwad02: 0,
          zwad03: this.bohuilist.tuzhiId.join(","),
          zwad04: 3,
          zwad05: localStorage.id,
          zwad06: new Date(),
        };
        list.push(zjwj_auditdata);
      }
      if (this.bohuilist.documentId.length > 0) {
        let zjwj_auditdata = {
          zwad01: 0,
          zwad02: 0,
          zwad03: this.bohuilist.documentId.join(","),
          zwad04: 4,
          zwad05: localStorage.id,
          zwad06: new Date(),
        };
        list.push(zjwj_auditdata);
      }
      // if (list.length == 0) {
      //   this.$message({
      //     type: "error",
      //     message: "请选择至少一项驳回内容",
      //   });
      //   return false;
      // }
      let params = {
        model: this.zjwj_planaudit,
        list: JSON.stringify(list),
      };
      let res = await ZjwjPlanAuditNoPass(params);
      if (res.Code > 0) {
        this.$message({
          type: "success",
          message: "驳回成功",
        });
        this.bohuiIsShow = false;
        this.ZjwjMyToAudit();
      }
    },
    viewModelOpen(data, data2) {
      if (data.zwpm08 === 3) {
        this.isTuZhi = true;
      }
      this.zjwj_crashcheck.zwcc02 = data.zwpm01;
      this.zjwj_crashcheck.zwcc06 = data.zwpm06;
      this.modelList = data2.fileList.filter((ele) => ele.zwpm08 === 1);
      this.tuzhiList = data2.fileList.filter((ele) => ele.zwpm08 === 3);
      this.pinshengIsShow = true;
      this.documentIsShow = false;
      var data = {
        url: this.$store.state.baseUrl + data.zwpm04,
        modelId: data.zwpm01,
        cid: localStorage.pid,
        xid: localStorage.xid,
        type: 1,
      };
      this.viewers(data);
    },
    viewers(data) {
      this.modelLoad = false;
      this.$nextTick(() => {
        ZJWJ.LoadModel(data);
        ``;
        var Interval = setInterval(() => {
          if (ZJWJ.modelLoad) {
            clearInterval(Interval);
            this.modelLoad = true;
          }
        }, 500);
      });
    },
    async ZjwjStartPlan(data) {
      let params = {
        id: data.zwpd01,
        type: 2,
      };
      let res = await ZjwjStartPlan(params);
      if (res.Code > 0) {
        this.$message({
          type: "success",
          message: "启动成功",
        });
        this.ZjwjMyToAudit();
      }
    },
    dialogTableVisibleOpen() {
      this.dialogTableVisible = true;
    },
    //请选择
    changePlanid(data) {
      this.planid = data;
      this.ZjwjMyToAudit();
    },
    async GetZjwjProjectPlan() {
      let params = {
        id: localStorage.xid,
        searchword: "",
        pageIndex: 1,
        type: 1,
        pageSize: 100000000,
      };
      let res = await GetZjwjProjectPlan({ params });
      if (res.Data.list.length > 0) {
        this.list = res.Data.list;
        this.planid = this.list[0].zwpp01;
        this.loading2 = true;
        if (this.$route.params.id) {
          this.planid = this.$route.params.id;
          this.palnDetailid = this.$route.params.palnDetailid;
        }
        this.ZjwjMyToAudit();
      }
    },
    async ZjwjMyToAudit() {
      let params = {
        xid:this.$store.state.xid,
        planid: this.planid,
        uid: localStorage.getItem("id"),
        searchword: this.searchword,
        xid: localStorage.xid,
      };
      let res = await ZjwjMyToAudit({ params });
      this.tableList = res.Data;
      this.initData(this.tableList);
      this.loading2 = false;
      this.polar = {
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)",
        },
        legend: {
          orient: "vertical",
          left: "right",
          right: "10px",
          data: [
            "未审核正常",
            "未审核延期",
            "审核中正常",
            "审核中延期",
            "已审核正常",
            "已审核延期",
          ],
        },
        series: [
          {
            name: "数据来源",
            type: "pie",
            radius: "40%",
            center: ["35%", "30%"],
            label: {
              // position:'inside'
            },
            data: [
              { value: this.wshzc, name: "未审核正常" },
              { value: this.yshyq, name: "未审核延期" },
              { value: this.shzzc, name: "审核中正常" },
              { value: this.shzyq, name: "审核中延期" },
              { value: this.yshzc, name: "已审核正常" },
              { value: this.yshyq, name: "已审核延期" },
            ],
            label: {
              //去除饼图的指示折线label
              normal: {
                show: false,
                position: "inside",
                formatter: "{b}:{d}%",
              },
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
      this.polar1 = {
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)",
        },
        legend: {
          orient: "vertical",
          left: "right",
          right: "10px",
          data: ["正常进行", "延期"],
        },
        series: [
          {
            name: "数据来源",
            type: "pie",
            radius: "40%",
            center: ["35%", "30%"],
            label: {
              // position:'inside'
            },
            data: [
              { value: this.zc, name: "正常进行" },
              { value: this.yyq, name: "延期" },
            ],
            label: {
              //去除饼图的指示折线label
              normal: {
                show: false,
                position: "inside",
                formatter: "{b}:{d}%",
              },
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
      this.polar2 = {
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)",
        },
        legend: {
          orient: "vertical",
          left: "right",
          right: "10px",
          data: ["正常任务项", "风险预警项"],
        },
        series: [
          {
            name: "数据来源",
            type: "pie",
            radius: "40%",
            center: ["35%", "30%"],
            label: {
              // position:'inside'
            },
            data: [
              { value: this.zcx, name: "正常任务项" },
              { value: this.fxx, name: "风险预警项" },
            ],
            label: {
              //去除饼图的指示折线label
              normal: {
                show: false,
                position: "inside",
                formatter: "{b}:{d}%",
              },
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
    },
    //高亮
    tableRowClassName({ row, rowIndex }) {
      if (row.zwpd01 == this.palnDetailid) {
        return "success-row";
      }
      return "";
    },
    //---
    initData(data) {
      this.resetEchartsData();
      data.forEach((ele) => {
        if (ele.children.length === 0) {
          this.zong++;
          switch (ele.auditstate) {
            case "已审核正常":
              this.yshzc++;
              this.ysh++;
              this.zc++;
              break;
            case "审核中正常":
              this.shzzc++;
              this.shz++;
              this.zc++;
              break;
            case "未审核正常":
              this.wshzc++;
              this.wsh++;
              this.zc++;
              break;
            case "已审核延期":
              this.yshyq++;
              this.ysh++;
              this.yyq++;
              break;
            case "审核中延期":
              this.shzyq++;
              this.shz++;
              this.yyq++;
              break;
            case "未审核延期":
              this.wshyq++;
              this.wsh++;
              this.yyq++;
              break;
          }
          switch (ele.isAuditDanger) {
            case 0:
              this.zcx++;
              break;
            case 1:
              this.fxx++;
              break;
          }
        }
        ele.fzId = ele.fzList.length > 0 ? ele.fzList[0].user01 : "";
        ele.shId = ele.shList.length > 0 ? ele.shList[0].user01 : "";
        if (ele.fileList) {
          ele.mId =
            ele.fileList.filter((ele) => ele.zwpm08 === 1).length > 0
              ? ele.fileList.filter((ele) => ele.zwpm08 === 1)[0].zwpm01
              : "";
          ele.cadId =
            ele.fileList.filter((ele) => ele.zwpm08 === 3).length > 0
              ? ele.fileList.filter((ele) => ele.zwpm08 === 3)[0].zwpm01
              : "";
          ele.wdId =
            ele.fileList.filter((ele) => ele.zwpm08 === 4).length > 0
              ? ele.fileList.filter((ele) => ele.zwpm08 === 4)[0].zwpm01
              : "";
        } else {
          ele.fileList = [];
        }
        if (ele.children.length > 0) {
          this.initData(ele.children);
        }
      });
    },
    resetEchartsData() {
      this.zong = 0;
      this.yshzc = 0;
      this.shzzc = 0;
      this.wshzc = 0;
      this.yshyq = 0;
      this.shzyq = 0;
      this.wshyq = 0;
      this.wsh = 0;
      this.shz = 0;
      this.ysh = 0;
      this.yyq = 0;
      this.zc = 0;
      this.zcx = 0;
      this.fxx = 0;
    },
  },
  mounted() {
    document.oncontextmenu = function () {
      return false;
    };
    Fcis.Fc(".lll", "#div_viewpoint");
    Fcis.Fc(".lll", "#crashCheckDiv");
  },
  filter: {},
  computed: {},
  watch: {},
};
</script>

<style lang="less" scoped>
.model {
  position: relative;
  width: 100%;
  height: 100%;
}
.flex {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}
.flexbetween {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.flex_al_jc {
  display: flex;
  justify-content: center;
  align-items: center;
}
.flex_fd {
  display: flex;
  flex-direction: column;
}
.ModelCompare {
  width: 100%;
  height: 700px;
  position: relative;
  .model {
    width: 50%;
    position: absolute;
    height: 700px;
  }
  .model3 {
    left: 50%;
    width: 50%;
  }
  .myborder-el-button {
    position: absolute;
    top: 20%;
    left: -0.5rem;
    z-index: 99;
    background: #fff;
    color: #00bcd4;
    border: 0.25rem solid #00bcd4;
    font-size: 2rem;
  }

  .divs {
    width: 50px;
    font-size: 14px;
    text-align: center;
    position: absolute;
    height: 150px;
    padding-top: 50px;
    margin-top: 2rem;
    z-index: 9;
    background: #00bcd4;
    border-radius: 0 0 10px 10px;
    div {
      width: 88%;
      height: 22px;
      border-radius: 2px;
      margin: 10px auto;
      cursor: pointer;
      &:nth-child(1) {
        background-color: rgb(255, 0, 0);
      }
      &:nth-child(2) {
        background-color: rgb(0, 128, 0);
      }
      &:nth-child(3) {
        background-color: rgb(218, 165, 32);
        color: #000000;
      }
      &:nth-child(4) {
        color: #000000;
        background-color: rgb(255, 255, 0);
      }
    }
  }
  .myBorder {
    z-index: 999;
    position: absolute;
    left: 49%;
    height: 700px;
    background: #00bcd4;
    color: #fff;
    font-size: 18px;
    display: flex;
    align-items: center;
  }
  .modelListOne {
    position: absolute;
    z-index: 999;
    top: 2%;
    left: 2%;
  }
  .modelListTwo {
    position: absolute;
    z-index: 999;
    top: 2%;
    left: 52%;
  }
}
/* 新增 */
</style>

<style lang="less" scoped>
@import url("../../../../public/Content/css/style.css");
#My2DViewerDiv {
  height: 95%;
  width: 100%;
  position: absolute;
}
.body_viewpoint {
  overflow: hidden;
  height: 91% !important;
  overflow-y: auto;
}
.body_viewpoint .treeDemo_viewpoint {
  width: 100%;
  max-height: 90%;
  min-height: 50%;
  padding-top: 5px;
  border: none;
}
.layer-background {
  background: rgba(255, 255, 255, 0.8) !important;
}
.liveBarCodeShow {
  z-index: 10;
  position: absolute;
  width: 410px;
  // background: #eee;
}
.search-input {
  width: 140px;
}
.back {
  background: #eee;
}
#middle1 {
  width: 0;
  height: 100%;
  position: absolute;
  top: 0;
  left: 50%;
  z-index: 10;
  border-left: 18px dashed transparent;
  margin-left: -9px;
  cursor: e-resize;
  display: none;
}

.reflex-layout.reflex-container {
  -ms-flex-pack: start;
  justify-content: flex-start;
  -ms-flex-align: stretch;
  align-items: stretch;
  -ms-flex-line-pack: stretch;
  align-content: stretch;
  display: -ms-flexbox;
  display: flex;
  position: relative;
  height: 100%;
  width: 100%;
}
.reflex-layout.reflex-container.horizontal {
  -ms-flex-direction: column;
  flex-direction: column;
}
.reflex-layout.reflex-container.vertical {
  -ms-flex-direction: row;
  flex-direction: row;
}
.reflex-layout > .reflex-element {
  position: relative;
  overflow: auto;
  height: 100%;
  width: 100%;
}
.reflex-layout > .reflex-splitter {
  background-color: #eee;
  z-index: 100;
}
.reflex-layout > .reflex-splitter.active,
.reflex-layout > .reflex-splitter:hover {
  background-color: #c6c6c6;
  transition: all 1s ease;
}
.reflex-layout.horizontal > .reflex-splitter {
  border-bottom: 1px solid #c6c6c6;
  border-top: 1px solid #c6c6c6;
  cursor: row-resize;
  width: 100%;
  height: 2px;
}
.reflex-layout.horizontal .reflex-handle {
  cursor: row-resize;
}
.reflex-layout.horizontal > .reflex-splitter.active,
.reflex-layout.horizontal > .reflex-splitter:hover {
  border-bottom: 1px solid #eee;
  border-top: 1px solid #eee;
}
.reflex-layout.vertical > .reflex-splitter {
  border-right: 1px solid #c6c6c6;
  border-left: 1px solid #c6c6c6;
  cursor: col-resize;
  height: 100%;
  width: 2px;
}
.reflex-layout.vertical .reflex-handle {
  cursor: col-resize;
}
.reflex-layout.vertical > .reflex-splitter.active,
.reflex-layout.vertical > .reflex-splitter:hover {
  border-right: 1px solid #eee;
  border-left: 1px solid #eee;
}
.reflex-layout > .reflex-splitter.reflex-thin {
  box-sizing: border-box;
  background: #000;
  background-clip: padding-box;
  opacity: 0.2;
  z-index: 100;
}
.reflex-layout
  > .reflex-splitter.reflex-thin.active
  .reflex-layout
  > .reflex-splitter.reflex-thin:hover {
  transition: all 1.5s ease;
  opacity: 0.5;
}
.reflex-layout.horizontal > .reflex-splitter.reflex-thin {
  border-bottom: 8px solid hsla(0, 0%, 100%, 0);
  border-top: 8px solid hsla(0, 0%, 100%, 0);
  height: 17px !important;
  cursor: row-resize;
  margin: -8px 0;
  width: 100%;
}
.reflex-layout.horizontal > .reflex-splitter.reflex-thin.active,
.reflex-layout.horizontal > .reflex-splitter.reflex-thin:hover {
  border-bottom: 8px solid #e4e4e4;
  border-top: 8px solid #e4e4e4;
}
.reflex-layout.vertical > .reflex-splitter.reflex-thin {
  border-right: 8px solid hsla(0, 0%, 100%, 0);
  border-left: 8px solid hsla(0, 0%, 100%, 0);
  width: 17px !important;
  cursor: col-resize;
  margin: 0 -8px;
  height: 100%;
}
.reflex-layout.vertical > .reflex-splitter.reflex-thin.active,
.reflex-layout.vertical > .reflex-splitter.reflex-thin:hover {
  border-right: 8px solid #e4e4e4;
  border-left: 8px solid #e4e4e4;
}
/deep/ .dropdown-ul li {
  width: 9.3%;
}
#menu_crashCheck_content_box .menu_table .box {
  width: 45%;
  margin-left: 2%;
  float: left;
  height: 85%;
  margin-bottom: 4px;
}
/deep/ .crashCheck_box {
  height: 700px;
  width: 300px;
  position: fixed;
  top: 10%;
  left: 60%;
  background: rgba(255, 255, 255);
}
/deep/ .el-upload {
  width: 100%;
}
#menu_crashCheck_content_box .menu_table .todo {
  line-height: 33px;
}
#menu_crashCheck_content_box .menu_table .box .export {
  line-height: 23px;
  margin: 0;
}
#div_viewpoint .body_viewpoint {
  max-height: 91%;
}
#sideMenuContainer,
#asideChatView,
#div_viewpoint {
  background: rgba(255, 255, 255);
}
.box_title {
  height: 3%;
}
.tab_title {
  height: 5%;
}
#menu_crashCheck_content_box {
  height: 92%;
}
.box_content {
  height: 97%;
}
.ztree {
  padding: 0px;
}
</style>
<style scoped>
.sdbcName {
  font-size: 20px;
  font-weight: 300;
  cursor: all-scroll;
}
.btnSearch {
  position: absolute;
  left: 0;
}
.pos-re-left4 {
  position: relative;
  left: 4px;
}
.clo1 {
  font-weight: 300;
  position: absolute;
  right: 0;
  color: #c3c3c3;
  font-size: 16px;
}
.w-h-bg-cor {
  height: 40px;
}
#vp-btn-mark {
  margin: 1px 0 0 66px;
  display: inline-block;
}
#vp-btn-save {
  display: inline-block;
}
.dis-none {
  display: none;
}
.rMenu {
  visibility: hidden;
}
.pos-fixed {
  position: fixed;
}
.dis-lis-item {
  /* display: inline-block; */
}
.filter_box {
  cursor: default;
  display: none;
}
.dis-bok {
  display: block;
}
.mar-top3 {
  margin-top: 3%;
}
.crashCheck_box {
  cursor: default;
}
.gray {
  opacity: 0;
}
.height40p {
  height: 40px;
}
.width100 {
  width: 100%;
}
#vp-searchtxt {
  padding-left: 20px;
}
</style>
<style lang="less" scoped>
.flex {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}
.flexbetween {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.flex_al_jc {
  display: flex;
  justify-content: center;
  align-items: center;
}
.flex_fd {
  display: flex;
  flex-direction: column;
}
/deep/.el-table .success-row {
  background: skyblue;
}
/deep/ .el-collapse-item__header {
  font-size: 18px;
}
</style>
